// extracted by css-extract-rspack-plugin
export default {"pagenav":"pagenav-2mhSA","outer":"outer-3GTby","current":"current-3qRSb","pagehit":"pagehit-8gyP-"};